import * as Accordion from '@radix-ui/react-accordion';
import { Table } from "@mui/joy";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import FormLabel from "@mui/joy/FormLabel";
import FormControl from "@mui/joy/FormControl";

export const ScoringClasificacionSBSIntegrante = (props: any) => {
 const { clasificacion } = props;

 return (
  <div className="border rounded-9 shadow p-3 p-md-4 mb-4 mb-md-4 cardTabs">
   <Accordion.Root className="AccordionRoot" type="single" defaultValue="item-1" collapsible>
    <Accordion.Item className="AccordionItem" value="item-1">
     <Accordion.Header>
      <div className="row g-2 mb-2 align-items-center">
       <div className="col-lg-4 textLabelHeadboard">
        <span className="fw-bold">CLASIFICACION SBS INTEGRANTE</span>
       </div>
       <div className="col-lg-4">
        <span className="fw-bold"> </span>
       </div>
       <div className="col-lg-4 textAlignRigth">
        <Accordion.Trigger>
         ^
        </Accordion.Trigger>
       </div>
      </div>
     </Accordion.Header>
     <Accordion.Content>
      <div className="row g-2 mb-2 align-items-center">
       <div className="col-lg-3 cardObjets">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
         <FormLabel>Periodo RCC</FormLabel>
         <FormLabel>{clasificacion.integrante.periodoRcc}</FormLabel>
        </LocalizationProvider>
       </div>
       <div className="col-lg-3 cardObjets">
        <FormControl>
         <FormLabel>Normal</FormLabel>
         <FormLabel>{clasificacion.integrante.normal}</FormLabel>
        </FormControl>
       </div>
       <div className="col-lg-3 cardObjets">
        <FormControl>
         <FormLabel>Problema potencial</FormLabel>
         <FormLabel>{clasificacion.integrante.problema}</FormLabel>
        </FormControl>
       </div>
       <div className="col-lg-3 cardObjets">
        <FormControl>
         <FormLabel>Deficiente</FormLabel>
         <FormLabel>{clasificacion.integrante.deficiente}</FormLabel>
        </FormControl>
       </div>
      </div>
      <div className="row g-2 mb-2 align-items-center">
       <div className="col-lg-3 cardObjets">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
         <FormLabel>Dudoso</FormLabel>
         <FormLabel>{clasificacion.integrante.dudoso}</FormLabel>
        </LocalizationProvider>
       </div>
       <div className="col-lg-3 cardObjets">
        <FormControl>
         <FormLabel>Perdida</FormLabel>
         <FormLabel>{clasificacion.integrante.perdida}</FormLabel>
        </FormControl>
       </div>
      </div>
      <div className="row g-2 mb-2 align-items-center borderOtherIncome">
       <div className="col-lg-4 textLabelHeadboard">
        <span className="fw-bold">REPORTE CREDITICIO DEUDA SBS</span>
       </div>
       <div className="col-lg-4">
        <span className="fw-bold"> </span>
       </div>
       <div className="row g-2 mb-2 align-items-center">
       <div className="col-lg-3 cardObjets">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
         <FormLabel>Línea disponible</FormLabel>
         <FormLabel>{clasificacion.integrante.lineaDisponible}</FormLabel>
        </LocalizationProvider>
       </div>
       <div className="col-lg-3 cardObjets">
        <FormControl>
         <FormLabel>Monto deuda S/</FormLabel>
         <FormLabel>{clasificacion.integrante.montoDeuda}</FormLabel>
        </FormControl>
       </div>
       </div>
      </div>
      <div className="row g-2 mb-2 align-items-center">
       <div className="col-lg-6 cardObjets align-top">
        <Table borderAxis="none" className="style-table align-top">
         <thead>
          <tr>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}>TIPO DEUDA</th>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", }}>ENTIDAD</th>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", }}>MONTO DEUDA</th>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", }}>CUOTA FC</th>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", }}>CUOTA REAL</th>
           <th style={{ width: "170px", backgroundColor: "#E1E1E1", }}>COMENTARIO</th>
          </tr>
         </thead>
         <tbody>
          {
           clasificacion.rerporte.map((row: any) => {
            return (
             <tr>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.tipoDeuda}</td>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.entidad}</td>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.montoDeuda}</td>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.cuotaFC}</td>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.cuotaReal}</td>
              <td style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px", }}> {row.comentario}</td>
            </tr>
            )
           })
          }
          <tr><td></td></tr>
          <tr><td></td></tr>
         </tbody>
        </Table>
       </div>
      </div>
     </Accordion.Content>
    </Accordion.Item>
   </Accordion.Root>
  </div>
 );
};

export default ScoringClasificacionSBSIntegrante;